import { render } from "./ZhaiBACard.vue?vue&type=template&id=207daac0&scoped=true"
import script from "./ZhaiBACard.vue?vue&type=script&lang=js"
export * from "./ZhaiBACard.vue?vue&type=script&lang=js"

import "./ZhaiBACard.vue?vue&type=style&index=0&id=207daac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207daac0"]])

export default __exports__